import * as THREE from 'three';
import { TABLE } from '../config';

/**
 * Billiard-hall lighting: soft ambient/hemisphere fill plus overhead spotlights,
 * one of which casts the soft ball-contact shadows. Scene is z-up.
 */
export function buildLighting(): THREE.Group {
  const group = new THREE.Group();

  group.add(new THREE.AmbientLight(0xffffff, 0.25));

  const hemi = new THREE.HemisphereLight(0xffffff, 0x202028, 0.5);
  hemi.position.set(0, 0, 3);
  group.add(hemi);

  const span = TABLE.playLength;
  const lampPositions: [number, number][] = [
    [0, -span / 4],
    [0, span / 4],
  ];

  lampPositions.forEach(([x, y], i) => {
    const spot = new THREE.SpotLight(0xfff4e0, 85, 6, Math.PI / 4, 0.45, 1.7);
    spot.position.set(x, y, 1.7);
    spot.target.position.set(x, y, 0);
    spot.castShadow = i === 0; // a single shadow caster keeps it cheap and clean
    if (spot.castShadow) {
      spot.shadow.mapSize.set(2048, 2048);
      spot.shadow.camera.near = 0.5;
      spot.shadow.camera.far = 4;
      spot.shadow.bias = -0.0002;
      // NOTE: inert under PCFSoftShadowMap (render/Renderer.ts) — that shader path
      // ignores `radius` and always spends a fixed 17 texture2DCompare taps per
      // shadowed fragment. Kept because it WOULD apply if the map type ever changes
      // back to plain PCF; don't reason about shadow softness or cost from it.
      spot.shadow.radius = 6;
    }
    group.add(spot);
    group.add(spot.target);
  });

  return group;
}
